import(/* webpackMode: "eager" */ "/tmp/8de4f2b4a367314/src/app/chat/page.tsx");
